import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import sanityClient from '../client.js';

export default function Project() {
  const [projectData, setProjectData] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "project"] | order(date desc){
      title,
      slug,
      altImage {
        asset->{
          _id,
          url,
        },
        alt,
        date
      }
    }`
      )
      .then((data) => setProjectData(data))
      .catch(console.error);
  }, []);

  return (
    <main className="bg-gray-300 min-h-screen p-12">
      <section className="container mx-auto">
        <h1 className="text-5xl flex justify-center starcraft">My Portfolio</h1>
        <h2 className="text-lg text-gray-600 flex justify-center mb-12">
          My Top Projects
        </h2>
        <section className="grid grid-cols-1 lg:grid-cols-2 md:grid-cols-2 gap-8">
          {projectData &&
            projectData.map((project, index) => (
              <article>
                <Link
                  to={'/project/' + project.slug.current}
                  key={project.slug.current}
                >
                  <span
                    className="block h-64 relative rounded shadow leading-snug bg-white border-l-8 border-indigo-500"
                    key={index}
                  >
                    <img
                      src={project.altImage.asset.url}
                      alt={project.altImage.alt}
                      className="w-full h-full rounded-r object-cover absolute"
                    />
                    <span className="block relative h-full flex justify-end items-end pr-4 pb-4">
                      <h3 className="text-gray-200 text-lg font-bold px-3 py-4 bg-indigo-500 text-gray-100 bg-opacity-75 rounded">
                        {project.title}
                      </h3>
                    </span>
                  </span>
                </Link>
              </article>
            ))}
        </section>
      </section>
    </main>
  );
}
